module.exports = __webpack_public_path__ + "main/assets/public/subscription-levels/more-info.770a610ac3608f09.svg";